import { useQuery } from '@tanstack/react-query';
import type { AdminStats } from 'admin-shared';
import { adminApi } from './client';

export const statsQueryKeys = {
  all: ['stats'] as const,
};

export function useStats() {
  return useQuery({
    queryKey: statsQueryKeys.all,
    queryFn:  () => adminApi.get<AdminStats>('/stats').then(r => r.data),
    staleTime: 60_000,
  });
}
